import { render, staticRenderFns } from "./Signature.vue?vue&type=template&id=b806c2f8&scoped=true"
import script from "./Signature.vue?vue&type=script&lang=js"
export * from "./Signature.vue?vue&type=script&lang=js"
import style0 from "./Signature.vue?vue&type=style&index=0&id=b806c2f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b806c2f8",
  null
  
)

export default component.exports